/**
 * Today as YYYY-MM-DD in the viewer's own time zone, for date inputs' `max`
 * and defaults (E18: a date that records something happening can't be later
 * than today; the server checks the same).
 *
 * @returns the local calendar date
 */
export function todayLocalISO(): string {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
